import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@sircon/sircon-ui-framework';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, of, takeUntil, tap } from 'rxjs';
import { CarrierService } from 'src/services/carrier.service';
import { CarrierInformation } from 'src/app/core/models/carrier-information.model';
import { NgIf, NgStyle } from '@angular/common';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
    selector: 'app-brand-information',
    templateUrl: './brand-information.component.html',
    styleUrls: ['./brand-information.component.less'],
    imports: [NgIf, NgStyle, NgxMaskPipe]
})
export class BrandInformationComponent extends BaseComponent implements OnInit {
    @Input() messageOverride: string = undefined;
    @Output() carrierInformationEvent = new EventEmitter<any>();
    @Output() loadingBrandEvent = new EventEmitter<boolean>();
    @Output() loadingErrorEvent = new EventEmitter<null>();
    brandKey;
    carrierInformation: CarrierInformation;

    constructor(
        private carrierService: CarrierService,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit(): void {
        this.brandKey = this.route.snapshot.queryParams.brandKey;
        this.loadBrandInformation();
    }

    loadBrandInformation() {
        if (this.brandKey) {
            this.loadingBrandEvent.emit(true);
            this.carrierService.getCarrierByBrand(this.brandKey)
                .pipe(
                    tap((response => {
                        this.carrierInformation = response;
                        this.carrierInformationEvent.emit(this.carrierInformation);
                    })),
                    catchError(() => {
                        this.loadingErrorEvent.emit();
                        return of(null);
                    }),
                    finalize(() => {
                        this.loadingBrandEvent.emit(false);
                    }),
                    takeUntil(this.ngUnsubscribe)
                )
                .subscribe();

        }
    }
}
